/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_OwnerInputs */

const es_chat_tool_detail_owner = /** @type {(inputs: Chat_Tool_Detail_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propietario`)
};

const en_chat_tool_detail_owner = /** @type {(inputs: Chat_Tool_Detail_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Chat_Tool_Detail_OwnerInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_owner = /** @type {((inputs?: Chat_Tool_Detail_OwnerInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_OwnerInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_owner(inputs)
	return en_chat_tool_detail_owner(inputs)
});
export { chat_tool_detail_owner as "chat.tool_detail.owner" }